import { Component, OnInit, Output, EventEmitter, Input, SecurityContext, ViewEncapsulation, ElementRef, ViewChild, Renderer2, RendererFactory2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import '@angular/localize/init';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { RankipediaService } from '@app/services/rankipedia.service';
import { isNullOrUndefined } from 'util';
import { AppHttpService } from '@app/services/app-http.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ranki-app-narrative-text',
  templateUrl: './narrative-text.component.html',
  styleUrls: ['./narrative-text.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NarrativeTextComponent implements OnInit {
  @ViewChild('narrative', { static: false }) textContainer: ElementRef;
  //@ViewChild("narrative", { static: false }) narrativeHtml;
  @Input() textkey: string = '';
  displayText: any;
  isLoaded: boolean = false;
  private renderer: Renderer2;

  constructor(
    private sanitizer: DomSanitizer,
    private _rankiService: RankipediaService,
    private rendererFactory: RendererFactory2
   ) {
    this.renderer = this.rendererFactory.createRenderer(null, null)
  }

  ngOnInit(): void {
      this.loadText();
  }
   
  loadText() {
    this._rankiService.getNarrativeText(this.textkey).subscribe(
      (data: any) => {
        this.displayText = data.Data;
        this.isLoaded = true;
        // Saved just in case
        // let text = this.sanitizer.sanitize(SecurityContext.HTML, data.Data);
        // const d: HTMLDivElement = this.renderer.createElement('d');
        // d.innerHTML = text;
        // this.renderer.appendChild(this.textContainer.nativeElement, d);
      },
      error => console.log('HTTP Error', error)
    );
  }
}
